import { SVGProps, Ref, forwardRef } from 'react';

export const MapFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.3.674c-1.137.632-2.278 1.258-3.387 1.937-1.257.77-2.515 1.653-3.2 3.001C.073 6.872 0 8.332 0 9.987v8.06c0 .867.023 1.669.133 2.322.096.564.334 1.558 1.231 2.152.962.637 1.998.387 2.561.193.622-.214 1.313-.589 2.023-1.005l1.352-.84zm1.8 19.731c1.934 1.085 3.872 2.163 5.8 3.258V3.599C12.974 2.519 11.03 1.437 9.1.34zm7.6-17.263v20.184c1.153-.648 2.308-1.292 3.443-1.972 1.24-.76 2.468-1.634 3.144-2.962.64-1.26.713-2.72.713-4.375v-8.06c0-.842-.022-1.618-.122-2.255-.087-.553-.296-1.482-1.077-2.1-.903-.714-1.933-.553-2.531-.375-.617.183-1.282.53-1.939.906z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MapFilledSize24Glyph.displayName = 'MapFilledSize24Glyph';
